var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-map"},[_c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.location,"zoom":17,"map-type-id":"roadmap"}},[_c('GmapMarker',{attrs:{"position":_vm.location,"clickable":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }